import { b as _extends } from './chunk-fb907809.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { theme } from 'styled-tools';
import styled from './styled.js';
import as from './as.js';
import Box from './Box.js';
import 'styled-components';
import '@emotion/is-prop-valid';
import 'hoist-non-react-statics';
import './chunk-a44fd1b3.js';
import './chunk-a7ce379e.js';

var Component = function Component(props) {
  if (props.block) {
    return React__default.createElement(Box, _extends({
      as: "pre"
    }, props), React__default.createElement("code", {
      className: props.codeClassName
    }, props.children));
  }

  var className = props.codeClassName ? (props.className + " " + props.codeClassName).trim() : ("" + props.className).trim();
  return React__default.createElement(Box, _extends({
    as: "code"
  }, props, {
    className: className
  }));
};

var Code = styled(Box).withConfig({
  displayName: "Code",
  componentId: "lzotsr-0"
})(["", ";"], theme("Code"));
Code.propTypes = {
  block: PropTypes__default.bool,
  codeClassName: PropTypes__default.string
};
Code.defaultProps = {
  opaque: true,
  palette: "background",
  tone: -2
};
var Code$1 = as(Component)(Code);

export default Code$1;
